/** The one freshness tracker of the kitchen screen: the orders sync writes it, the banner reads it. */
import { createFreshness } from "./freshness";

export const kitchenFreshness = createFreshness();
